import { seriesConstants } from "@constants";

export function series (state = {}, action) {
    switch (action.type) {
        case seriesConstants.SERIES_REQUEST:
            return { 
                ...state,
                isLoading: true 
            };
        case seriesConstants.SERIES_SUCCESS:
            return {
                ...state,
                data: action.payload,
                isLoading: false
            };
        case seriesConstants.SERIES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        default: return state;
    }
};